import { getMenuTypeElementChanges } from './chunk-CNYOJTOU.mjs';
import { getMenuTypesItemsChanges } from './chunk-SWAUA3KU.mjs';
import { getTaxesDiffArrayCore, getArrayNumberChanges } from './chunk-RPUBZJ2D.mjs';
import { selectCurrentItem, selectOriginalMenuData, selectMenu } from './chunk-PHOCK55S.mjs';
import { i18n_config_default } from './chunk-SGCJ7UYI.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import groupBy from 'lodash/groupBy';

var CategoryMasterFieldLabels = /* @__PURE__ */ ((CategoryMasterFieldLabels2) => {
  CategoryMasterFieldLabels2[CategoryMasterFieldLabels2["name"] = 0] = "name";
  CategoryMasterFieldLabels2[CategoryMasterFieldLabels2["customizer"] = 1] = "customizer";
  return CategoryMasterFieldLabels2;
})(CategoryMasterFieldLabels || {});
var CategoryBasicSectionFieldLabels = /* @__PURE__ */ ((CategoryBasicSectionFieldLabels2) => {
  CategoryBasicSectionFieldLabels2[CategoryBasicSectionFieldLabels2["posName"] = 0] = "posName";
  CategoryBasicSectionFieldLabels2[CategoryBasicSectionFieldLabels2["active"] = 1] = "active";
  CategoryBasicSectionFieldLabels2[CategoryBasicSectionFieldLabels2["backgroundColor"] = 2] = "backgroundColor";
  CategoryBasicSectionFieldLabels2[CategoryBasicSectionFieldLabels2["textColor"] = 3] = "textColor";
  return CategoryBasicSectionFieldLabels2;
})(CategoryBasicSectionFieldLabels || {});
var CategoryMoreInformationFieldLabels = /* @__PURE__ */ ((CategoryMoreInformationFieldLabels2) => {
  CategoryMoreInformationFieldLabels2[CategoryMoreInformationFieldLabels2["description"] = 0] = "description";
  return CategoryMoreInformationFieldLabels2;
})(CategoryMoreInformationFieldLabels || {});
var CategoryAssociationsFieldLabels = /* @__PURE__ */ ((CategoryAssociationsFieldLabels2) => {
  CategoryAssociationsFieldLabels2[CategoryAssociationsFieldLabels2["itemIds"] = 0] = "itemIds";
  CategoryAssociationsFieldLabels2[CategoryAssociationsFieldLabels2["subcategoryIds"] = 1] = "subcategoryIds";
  CategoryAssociationsFieldLabels2[CategoryAssociationsFieldLabels2["comboIds"] = 2] = "comboIds";
  return CategoryAssociationsFieldLabels2;
})(CategoryAssociationsFieldLabels || {});
var returnLabel = (field) => {
  if (field in CategoryMasterFieldLabels) {
    return i18n_config_default.t(
      `app.modals.categoriesDiffModal.master.${field}`
    );
  }
  if (field in CategoryBasicSectionFieldLabels) {
    return i18n_config_default.t(
      `app.modals.categoriesDiffModal.basic.${field}`
    );
  }
  if (field in CategoryMoreInformationFieldLabels) {
    return i18n_config_default.t(
      `app.modals.categoriesDiffModal.moreInfo.${field}`
    );
  }
  if (field in CategoryAssociationsFieldLabels) {
    return i18n_config_default.t(
      `app.modals.categoriesDiffModal.associations.${field}`
    );
  }
};
var diffCategoriesFactory = (categoryId, diffArray, state) => {
  if (diffArray.length > 0) {
    const changeData = selectCurrentItem(state);
    const originalData = selectOriginalMenuData(state);
    const formattedDiffArray = diffArray.filter(
      (diff) => diff.path.length === 1 && diff.path[0] !== "itemIds" && diff.path[0] !== "subcategoryItemsIds" && diff.path[0] !== "comboIds" && diff.path[0] !== "subcategoryCombosIds"
    ).map((diff) => {
      var _a, _b;
      if (!diff.path)
        return { field: null };
      const field = diff.path[((_a = diff.path) == null ? void 0 : _a.length) - 1];
      return {
        field,
        label: (_b = returnLabel(field)) != null ? _b : "",
        value: diff.rhs
      };
    });
    const { masterChanges, basicChanges, moreInformationChanges } = filterChangesBySection(formattedDiffArray);
    return {
      categoryId,
      masterChanges,
      basic: basicChanges,
      moreInfo: moreInformationChanges,
      associations: getCategoryAssociationsChanges(state),
      taxes: getTaxesDiffArrayCore(
        originalData.taxIds,
        changeData.taxIds,
        state
      )
    };
  }
  return null;
};
var getCategoryAssociationsChanges = (state) => {
  const menu = selectMenu(state);
  const subcategories = menu.subcategories;
  const originalData = selectOriginalMenuData(state);
  const currentData = selectCurrentItem(state);
  const currentSubcategoryMenuTypeItemsIds = currentData.subcategoryMenuTypeItemsIds;
  const currentSubcategoryMenuTypeCombosIds = currentData.subcategoryMenuTypeCombosIds;
  const originalSubcategoryMenuTypeItemsIds = originalData.subcategoryMenuTypeItemsIds;
  const originalSubcategoryMenuTypeCombosIds = originalData.subcategoryMenuTypeCombosIds;
  const subcategoriesChanges = [];
  const subMapFn = (change) => __spreadProps(__spreadValues({}, change), {
    id: !change.id ? null : change.id,
    value: !change.id ? i18n_config_default.t(
      "menuScreen.categoryDetails.associations.subcategories.noSubcategory"
    ) : subcategories[change.id].name
  });
  const subcategoriesItemsChanges = getArrayNumberChanges(
    originalData.subcategoryIds.filter((id) => id > 0),
    currentData.subcategoryIds.filter((id) => id > 0)
  ).map(subMapFn);
  if (subcategoriesItemsChanges.length > 0) {
    subcategoriesChanges.push({
      field: "subcategoryIds",
      label: returnLabel("subcategoryIds") || "",
      value: subcategoriesItemsChanges
    });
  }
  const subcategoryItemIds = Array.from(
    /* @__PURE__ */ new Set([
      ...Object.keys(originalSubcategoryMenuTypeItemsIds),
      ...Object.keys(currentSubcategoryMenuTypeItemsIds)
    ])
  ).map(Number);
  const subcategoryComboIds = Array.from(
    /* @__PURE__ */ new Set([
      ...Object.keys(originalSubcategoryMenuTypeCombosIds),
      ...Object.keys(currentSubcategoryMenuTypeCombosIds)
    ])
  ).map(Number);
  let itemChanges = [];
  let comboChanges = [];
  const subcategoryChangeMap = (change, subcategoryId, originalSubcategoryMenuTypeElementIds) => {
    const isUpdate = Object.values(originalSubcategoryMenuTypeElementIds).some(
      (menuTypeElementIds) => menuTypeElementIds[change.menuTypeId] && menuTypeElementIds[change.menuTypeId].includes(change.id)
    );
    return __spreadProps(__spreadValues({}, change), {
      action: isUpdate && change.action === "add" ? "update" : change.action,
      subcategoryId: !subcategoryId ? null : subcategoryId,
      subcategoryValue: !subcategoryId ? i18n_config_default.t(
        "menuScreen.categoryDetails.associations.subcategories.noSubcategory"
      ) : subcategories[subcategoryId].name
    });
  };
  subcategoryItemIds.forEach((subcategoryId) => {
    const menuTypeItemIdsChanges = getMenuTypeElementChanges(
      originalData.subcategoryMenuTypeItemsIds[subcategoryId] || {},
      currentData.subcategoryMenuTypeItemsIds[subcategoryId] || {},
      menu.items,
      menu.menuTypes
    );
    itemChanges.push(
      ...menuTypeItemIdsChanges.map(
        (change) => subcategoryChangeMap(
          change,
          subcategoryId,
          originalData.subcategoryMenuTypeItemsIds
        )
      )
    );
  });
  subcategoryComboIds.forEach((subcategoryId) => {
    const menuTypeComboIdsChanges = getMenuTypeElementChanges(
      originalData.subcategoryMenuTypeCombosIds[subcategoryId] || {},
      currentData.subcategoryMenuTypeCombosIds[subcategoryId] || {},
      menu.combos,
      menu.menuTypes
    );
    comboChanges.push(
      ...menuTypeComboIdsChanges.map(
        (change) => subcategoryChangeMap(
          change,
          subcategoryId,
          originalData.subcategoryMenuTypeCombosIds
        )
      )
    );
  });
  const filterFn = (change, id, menuTypeId) => change.id !== Number(id) || change.menuTypeId !== Number(menuTypeId) || (change.action === "add" || change.action === "update") && change.id === Number(id) && change.menuTypeId === Number(menuTypeId);
  Object.entries(
    groupBy(itemChanges, (change) => `${change.id}-${change.menuTypeId}`) || {}
  ).forEach(([key, value]) => {
    const [id, menuTypeId] = key.split("-");
    if (value.length > 1) {
      itemChanges = itemChanges.filter(
        (change) => filterFn(change, id, menuTypeId)
      );
    }
  });
  Object.entries(
    groupBy(comboChanges, (change) => `${change.id}-${change.menuTypeId}`) || {}
  ).forEach(([key, value]) => {
    const [id, menuTypeId] = key.split("-");
    if (value.length > 1) {
      comboChanges = comboChanges.filter(
        (change) => filterFn(change, id, menuTypeId)
      );
    }
  });
  const associationsChanges = {
    items: itemChanges.length > 0 ? [
      {
        field: "itemIds",
        label: returnLabel("itemIds") || "",
        value: itemChanges
      }
    ] : [],
    combos: comboChanges.length > 0 ? [
      {
        field: "comboIds",
        label: returnLabel("comboIds") || "",
        value: comboChanges
      }
    ] : [],
    subcategories: subcategoriesChanges
  };
  return associationsChanges;
};
var filterChangesBySection = (formattedDiffArray) => {
  const masterChanges = formattedDiffArray.filter(
    (diff) => diff.field ? Object.keys(CategoryMasterFieldLabels).filter((value) => isNaN(Number(value))).includes(diff.field) : false
  );
  const basicChanges = formattedDiffArray.filter(
    (diff) => diff.field ? Object.keys(CategoryBasicSectionFieldLabels).filter((value) => isNaN(Number(value))).includes(diff.field) : false
  );
  const moreInformationChanges = formattedDiffArray.filter(
    (diff) => diff.field ? Object.keys(CategoryMoreInformationFieldLabels).filter((value) => isNaN(Number(value))).includes(diff.field) : false
  );
  return {
    masterChanges,
    basicChanges,
    moreInformationChanges
  };
};
var getSubcategoryOfItemChanges = (hasSomeSubcategoryItemsIds, bucketSubcategoryItemsIdsObj, currentSubcategoryItemsIds) => {
  const changes = Object.entries(currentSubcategoryItemsIds).map(([subcategoryId, itemIds]) => {
    const bucketItemIds = bucketSubcategoryItemsIdsObj[Number(subcategoryId)];
    return {
      subcategoryId: Number(subcategoryId),
      changes: getMenuTypesItemsChanges(
        hasSomeSubcategoryItemsIds,
        bucketItemIds,
        itemIds
      ).filter((change) => change.action !== "remove")
    };
  }).filter((subcategory) => subcategory.changes.length > 0);
  return changes;
};

export { CategoryAssociationsFieldLabels, CategoryBasicSectionFieldLabels, CategoryMasterFieldLabels, CategoryMoreInformationFieldLabels, diffCategoriesFactory, getCategoryAssociationsChanges, getSubcategoryOfItemChanges };
